import { Model, modelRegistry } from './Model';
export class OrderItemComment extends Model {
    static entity = 'order_item_comments';
    id = null;
    comment = null;
    /** The product categories the POS offers the comment for; empty = every item. */
    category_ids = [];
    created_at = null;
    updated_at = null;
    static fields() {
        return {
            id: this.attr(null),
            comment: this.attr(null),
            category_ids: this.attr([]),
            created_at: this.attr(null),
            updated_at: this.attr(null),
        };
    }
    /**
     * The comments the POS offers for an item of category `categoryId` — null for a product with no
     * category, or one no longer loaded: the comments without a category, and that category's.
     * With no category assigned anywhere, every comment.
     */
    static offeredFor(categoryId) {
        return this.all().filter(comment => !comment.category_ids?.length || (categoryId !== null && comment.category_ids.includes(categoryId)));
    }
    constructor(record) {
        super();
        this.$fill(record);
    }
}
export default OrderItemComment;
modelRegistry.register('OrderItemComment', OrderItemComment);
//# sourceMappingURL=OrderItemComment.js.map